import { FormikProps } from 'formik';
// import { FaCalendarAlt } from 'react-icons/fa';
import {
  CardBody,
  CardHeader,
  Col,
  FormGroup,
  Input,
  // InputGroup,
  // InputGroupText,
  Label,
} from 'reactstrap';
import { CustomerFormType } from 'types/customer/customerTypes';
import { useTranslation } from 'react-i18next';
import Flatpickr from 'react-flatpickr';
import { Thai } from 'flatpickr/dist/l10n/th';
import { useCallback, useRef } from 'react';
import Select from 'react-select';
import { CustomReactSelectStyles } from 'styles/common/singleSelectStyle';
import { useSelector } from 'react-redux';
import { RootState } from 'slices';
import {
  EntityTypeOptions,
  GenderOptions,
} from 'pages/Customers/CustomerManagementModals/constants';
import useWindowSize from 'Components/Hooks/WindowSizeHook';
import { BOOTSTRAP_BREAKPOINTS } from 'utils/bootstrapBreakpoints';

type Option = { label: string; value: string };

const CustomerInfoSection = ({
  formik,
  availableBranchAccess,
}: {
  formik: FormikProps<CustomerFormType>;
  availableBranchAccess: boolean;
}) => {
  const { t, i18n } = useTranslation();
  const layoutState = useSelector((state: RootState) => state.Layout);
  const { layoutModeType } = layoutState;
  const infoState = useSelector((state: RootState) => state.Info);
  const { branches } = infoState;
  const customerState = useSelector((state: RootState) => state.Customer);
  const { showAllValidateErrors, isEdit } = customerState;
  const { width } = useWindowSize();
  const isMobile = width <= 1024;
  const isLargeScreen =
    width < BOOTSTRAP_BREAKPOINTS.xl && width > BOOTSTRAP_BREAKPOINTS.sm;
  const isXSScreen = width <= BOOTSTRAP_BREAKPOINTS.sm;
  const isDarkMode = layoutModeType === 'dark';
  const entityTypeOptions = EntityTypeOptions(t);
  const genderOptions = GenderOptions(t);
  const getLocale = useCallback(() => {
    switch (i18n.language) {
      case 'th':
        return Thai;

      default:
        return undefined;
    }
  }, [i18n.language]);
  const birthDateRef = useRef<any>(null);
  const getOpt = (opts: Option[], value?: string) =>
    value ? (opts.find((o) => o.value === value) ?? null) : null;
  return (
    <>
      {/* <div
        className="mb-4 accent-bar"
        // style={{ fontSize: '16px', fontWeight: '600' }}
        // style={{
        //   fontSize: '1rem',
        //   fontWeight: '600',
        //   margin: '1.25rem 0 0.75rem',
        //   paddingLeft: '0.75rem',
        //   borderLeft: '4px solid #4bb189',
        //   color: '#212529',
        // }}
      >
        {t('Customer Information')}
      </div> */}
      <CardHeader className="mb-4 mx-0 px-0">
        <div
          className="px-0 mx-0"
          style={{
            fontSize: '1rem',
            fontWeight: '600',
            display: 'inline-flex',
          }}
        >
          <div className={`text-success`}>
            <i className="ri-user-settings-line"></i>
          </div>
          <div className="px-1">{t('Customer Information')}</div>
        </div>
      </CardHeader>
      <CardBody
        style={{
          paddingLeft: isMobile ? '' : '2rem',
          paddingRight: isMobile ? '' : '2rem',
        }}
      >
        {isEdit && availableBranchAccess && (
          <div className=" row">
            <Col sm={3}>
              <Label htmlFor="#" className="col-form-label">
                {t('Branch')}
                <span style={{ color: 'red' }}>*</span>
              </Label>
            </Col>
            <Col sm={9}>
              <FormGroup key={1}>
                <Select
                  styles={CustomReactSelectStyles(isDarkMode)}
                  id="register_store_id"
                  name="register_store_id"
                  data-testid="register_store_id"
                  options={branches}
                  value={getOpt(
                    branches,
                    formik.values.customerInfo.register_store_id
                  )}
                  onChange={(opt: any) => {
                    // Clear lower-level selections when province changes (common UX)
                    formik
                      .setFieldValue(
                        'customerInfo.register_store_id',
                        opt?.value ?? ''
                      )
                      .then(() => {
                        formik.setFieldTouched(
                          'customerInfo.register_store_id',
                          true
                        );
                      });
                  }}
                  onBlur={() =>
                    formik.setFieldTouched(
                      'customerInfo.register_store_id',
                      true
                    )
                  }
                  placeholder={t('ProductPage_PleaseSelect')}
                />
              </FormGroup>
            </Col>
          </div>
        )}

        <div className="mb-1 row">
          <Label
            htmlFor="customerInfo.entity_type"
            className="col-sm-3 col-form-label"
          >
            {t('Entity Type')}
            <span style={{ color: 'red' }}>*</span>
          </Label>
          <Col sm={9}>
            <div className="mt-2">
              <FormGroup key={1}>
                {entityTypeOptions.map(
                  (p: { label: string; value: string }, _index) => (
                    <div key={p.value} className="form-check form-check-inline">
                      <Input
                        className="form-check-input"
                        type="radio"
                        name="customerInfo.entity_type"
                        id={p.label}
                        value={p.value}
                        checked={
                          formik.values.customerInfo.entity_type === p.value
                        }
                        onChange={(e) => {
                          formik.handleChange(e);
                        }}
                        onBlur={(e) => {
                          formik.handleBlur(e);
                        }}
                      />
                      <Label className="form-check-label" htmlFor={p.label}>
                        {p.label}
                      </Label>
                    </div>
                  )
                )}
                {(formik.touched.customerInfo?.entity_type &&
                  formik.errors.customerInfo?.entity_type &&
                  typeof formik.errors.customerInfo.entity_type === 'string') ||
                (formik.isValid === false &&
                  formik.errors.customerInfo?.entity_type &&
                  showAllValidateErrors === true) ? (
                  <div className={`text-danger `}>
                    {formik.errors.customerInfo.entity_type}
                  </div>
                ) : null}
              </FormGroup>
            </div>
          </Col>
        </div>

        <div className="mb-3 row">
          <Label
            htmlFor="customerInfo.accountNumber"
            className="col-sm-3 col-form-label"
          >
            {t('Account Number')}
          </Label>
          <Col sm={9}>
            <Input
              type="text"
              className="form-control"
              id="customerInfo.accountNumber"
              name="customerInfo.accountNumber"
              value={formik.values.customerInfo.accountNumber}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              maxLength={255}
            />
            {(formik.touched.customerInfo?.accountNumber &&
              formik.errors.customerInfo?.accountNumber &&
              typeof formik.errors.customerInfo.accountNumber === 'string') ||
            (formik.isValid === false &&
              formik.errors.customerInfo?.accountNumber &&
              showAllValidateErrors === true) ? (
              <div className={`text-danger `}>
                {formik.errors.customerInfo.accountNumber}
              </div>
            ) : null}
          </Col>
        </div>

        <div className="mb-3 row">
          <Label
            htmlFor="customerInfo.first_name"
            className="col-sm-3 col-form-label"
          >
            {formik.values.customerInfo.entity_type === '1'
              ? t('Corporate Name')
              : t('Customer Name')}
            <span style={{ color: 'red' }}>*</span>
          </Label>
          <Col sm={9}>
            <Input
              type="text"
              className="form-control"
              id="customerInfo.first_name"
              name="customerInfo.first_name"
              value={formik.values.customerInfo.first_name}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              maxLength={255}
            />
            {(formik.touched.customerInfo?.first_name &&
              formik.errors.customerInfo?.first_name &&
              typeof formik.errors.customerInfo.first_name === 'string') ||
            (formik.isValid === false &&
              formik.errors.customerInfo?.first_name &&
              showAllValidateErrors === true) ? (
              <div className={`text-danger `}>
                {formik.errors.customerInfo.first_name}
              </div>
            ) : null}
          </Col>
        </div>

        <div className="mb-3 row">
          <Label
            htmlFor="customerInfo.cardId"
            className="col-sm-3 col-form-label"
          >
            {t('Tax ID')}
          </Label>
          <Col sm={9}>
            <Input
              type="text"
              className="form-control"
              id="customerInfo.cardId"
              name="customerInfo.cardId"
              value={formik.values.customerInfo.cardId}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              maxLength={255}
            />
            {(formik.touched.customerInfo?.cardId &&
              formik.errors.customerInfo?.cardId &&
              typeof formik.errors.customerInfo.cardId === 'string') ||
            (formik.isValid === false &&
              formik.errors.customerInfo?.cardId &&
              showAllValidateErrors === true) ? (
              <div className={`text-danger `}>
                {formik.errors.customerInfo.cardId}
              </div>
            ) : null}
          </Col>
        </div>

        {formik.values.customerInfo.entity_type === '1' && (
          <div className="mb-3 row">
            <Label
              htmlFor="customerInfo.branchCode"
              className="col-sm-3 col-form-label"
            >
              {t('Branch Code')}
            </Label>
            <Col sm={9}>
              <Input
                type="text"
                className="form-control"
                id="customerInfo.branchCode"
                name="customerInfo.branchCode"
                value={formik.values.customerInfo.branchCode}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                maxLength={255}
              />
              <div className="text-muted pt-1" style={{ fontSize: '0.75rem' }}>
                {'* 0000 ' + t('Head office')}
              </div>
              {(formik.touched.customerInfo?.branchCode &&
                formik.errors.customerInfo?.branchCode &&
                typeof formik.errors.customerInfo.branchCode === 'string') ||
              (formik.isValid === false &&
                formik.errors.customerInfo?.branchCode &&
                showAllValidateErrors === true) ? (
                <div className={`text-danger `}>
                  {formik.errors.customerInfo.branchCode}
                </div>
              ) : null}
            </Col>
          </div>
        )}

        {formik.values.customerInfo.entity_type === '1' && (
          <div className="mb-3 row">
            <Label
              htmlFor="customerInfo.address_2"
              className="col-sm-3 col-form-label"
            >
              {t('Branch Name')}
            </Label>
            <Col sm={9}>
              <Input
                type="text"
                className="form-control"
                id="customerInfo.address_2"
                name="customerInfo.address_2"
                value={formik.values.customerInfo.address_2}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                maxLength={255}
              />
              {(formik.touched.customerInfo?.address_2 &&
                formik.errors.customerInfo?.address_2 &&
                typeof formik.errors.customerInfo.address_2 === 'string') ||
              (formik.isValid === false &&
                formik.errors.customerInfo?.address_2 &&
                showAllValidateErrors === true) ? (
                <div className={`text-danger `}>
                  {formik.errors.customerInfo.address_2}
                </div>
              ) : null}
            </Col>
          </div>
        )}

        {/* {formik.values.customerInfo.entity_type === '0' && (
          <div className="mb-3 row">
            <Label
              htmlFor="customerInfo.birthDate"
              className="col-sm-3 col-form-label"
            >
              {t('Birth Date')}
            </Label>
            <Col sm={9}>
              <InputGroup className="mb-2">
                <Flatpickr
                  ref={birthDateRef}
                  id="customerInfo.birthDate"
                  name="customerInfo.birthDate"
                  className="form-control"
                  options={{
                    dateFormat: 'd M, Y',
                    locale: getLocale(),
                  }}
                  value={formik.values.customerInfo.birthDate || ''}
                  onChange={(date) => {
                    console.log(date);
                    formik
                      .setFieldValue('customerInfo.birthDate', date[0])
                      .then(() =>
                        formik.setFieldTouched('customerInfo.birthDate', true)
                      );
                  }}
                  onClick={() => {
                    formik.setFieldTouched('customerInfo.birthDate', true);
                  }}
                />
                <InputGroupText
                  onClick={() => birthDateRef.current?.flatpickr?.open()}
                  style={{ cursor: 'pointer' }}
                >
                  <FaCalendarAlt className={`${fontColorClass}`} />
                </InputGroupText>
              </InputGroup>
            </Col>
          </div>
        )} */}

        {/* {formik.values.customerInfo.entity_type === '0' && (
          <div className="mb-3 row">
            <Label
              htmlFor="customerInfo.gender"
              className="col-sm-3 col-form-label"
            >
              {t('Gender')}
            </Label>
            <Col sm={9}>
              <Select
                styles={CustomReactSelectStyles(isDarkMode)}
                value={
                  formik.values.customerInfo.gender
                    ? genderOptions.find(
                        (option: { value: string }) =>
                          option.value === formik.values.customerInfo.gender
                      )
                    : null
                }
                onChange={(option: { value: string }) => {
                  formik
                    .setFieldValue('customerInfo.gender', option?.value)
                    .then(() =>
                      formik.setFieldTouched('customerInfo.gender', true)
                    );
                }}
                onBlur={() => {
                  formik.setFieldTouched('customerInfo.gender', true);
                }}
                options={genderOptions}
                name="customerInfo.gender"
                id="customerInfo.gender"
                placeholder={t('Gender')}
              />
              {(formik.touched.customerInfo?.gender &&
                formik.errors.customerInfo?.gender &&
                typeof formik.errors.customerInfo.gender === 'string') ||
              (formik.isValid === false &&
                formik.errors.customerInfo?.gender &&
                showAllValidateErrors === true) ? (
                <div className={`text-danger `}>
                  {formik.errors.customerInfo.gender}
                </div>
              ) : null}
            </Col>
          </div>
        )} */}

        {formik.values.customerInfo.entity_type === '0' && (
          <div className="mb-3 row">
            <Label
              htmlFor="customerInfo.birthDate"
              className="col-sm-3 col-form-label"
            >
              {t('Birth Date')}
            </Label>

            <Col xl={4} sm={9}>
              <Flatpickr
                ref={birthDateRef}
                id="customerInfo.birthDate"
                name="customerInfo.birthDate"
                className="form-control"
                options={{
                  dateFormat: 'd M, Y',
                  locale: getLocale(),
                }}
                value={formik.values.customerInfo.birthDate || ''}
                onChange={(date) => {
                  console.log(date);
                  formik
                    .setFieldValue('customerInfo.birthDate', date[0])
                    .then(() =>
                      formik.setFieldTouched('customerInfo.birthDate', true)
                    );
                }}
                onClick={() => {
                  formik.setFieldTouched('customerInfo.birthDate', true);
                }}
              />
              {/* <InputGroupText
                  onClick={() => birthDateRef.current?.flatpickr?.open()}
                  style={{ cursor: 'pointer' }}
                >
                  <FaCalendarAlt className={`${fontColorClass}`} />
                </InputGroupText> */}
            </Col>

            <Label
              htmlFor="customerInfo.gender"
              className={`col-xl-1 col-sm-3 col-form-label ${isLargeScreen || isXSScreen ? 'mt-3' : ''}`}
            >
              {t('Gender')}
            </Label>

            <Col xl={4} sm={9} className={`${isLargeScreen ? 'mt-3' : ''}`}>
              <Select
                styles={CustomReactSelectStyles(isDarkMode)}
                value={
                  formik.values.customerInfo.gender
                    ? genderOptions.find(
                        (option: { value: string }) =>
                          option.value === formik.values.customerInfo.gender
                      )
                    : null
                }
                onChange={(option: { value: string }) => {
                  formik
                    .setFieldValue('customerInfo.gender', option?.value)
                    .then(() =>
                      formik.setFieldTouched('customerInfo.gender', true)
                    );
                }}
                onBlur={() => {
                  formik.setFieldTouched('customerInfo.gender', true);
                }}
                options={genderOptions}
                name="customerInfo.gender"
                id="customerInfo.gender"
                placeholder={t('Gender')}
              />
              {(formik.touched.customerInfo?.gender &&
                formik.errors.customerInfo?.gender &&
                typeof formik.errors.customerInfo.gender === 'string') ||
              (formik.isValid === false &&
                formik.errors.customerInfo?.gender &&
                showAllValidateErrors === true) ? (
                <div className={`text-danger `}>
                  {formik.errors.customerInfo.gender}
                </div>
              ) : null}
            </Col>
          </div>
        )}

        <div className="mb-3 row">
          <Label
            htmlFor="customerInfo.comments"
            className="col-sm-3 col-form-label"
          >
            {t('Comments')}
          </Label>
          <Col sm={9}>
            <textarea
              className="form-control"
              id="customerInfo.comments"
              name="customerInfo.comments"
              value={formik.values.customerInfo.comments}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              rows={3}
            ></textarea>

            {(formik.touched.customerInfo?.comments &&
              formik.errors.customerInfo?.comments &&
              typeof formik.errors.customerInfo.comments === 'string') ||
            (formik.isValid === false &&
              formik.errors.customerInfo?.comments &&
              showAllValidateErrors === true) ? (
              <div className={`text-danger `}>
                {formik.errors.customerInfo.comments}
              </div>
            ) : null}
          </Col>
        </div>

        <div className="mb-3 row"></div>
      </CardBody>
    </>
  );
};

export default CustomerInfoSection;
